import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-no-item-message',
  imports: [],
  templateUrl: './no-item-message.component.html',
  styleUrl: './no-item-message.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoItemMessageComponent {
  public readonly message = input.required<string>();
}
